export default __webpack_public_path__ + "static/media/shape.4494b3f6.png";